// Dev: REACT_APP_API_URL not set → http://localhost:8000
// Prod: set REACT_APP_API_URL=/api before npm run build
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';
